import api from './api';

const AGENT_API_BASE = '/agent/invoice';

const agentService = {
    // Get all pending invoice previews (Grouped missions suggested by AI)
    getPendingPreviews: async () => {
        const response = await api.get(`${AGENT_API_BASE}/previews`);
        // The Java backend returns the list of previews directly
        return response.data;
    },

    // Update price for a specific mission within a preview
    updateMissionPrice: async (previewId, missionId, newPrice, reason = 'Modification manuelle via UI') => {
        const response = await api.post(`${AGENT_API_BASE}/previews/${previewId}/update-price`, {
            mission_id: missionId,
            new_price: newPrice,
            reason: reason
        });
        return response.data;
    },

    // Generate final invoices from a preview
    createFinalInvoices: async (previewId, extraEmails = '') => {
        const response = await api.post(`${AGENT_API_BASE}/previews/${previewId}/validate`, {
            extra_emails: extraEmails
        });
        return response.data;
    },

    // Get PDF preview as Blob (to handle authentication)
    getPreviewPdfBlob: async (previewId) => {
        const response = await api.get(`${AGENT_API_BASE}/previews/${previewId}/pdf`, {
            responseType: 'blob'
        });
        return response.data;
    }
};

export default agentService;
